import { Navigate, Outlet } from "react-router-dom";
import { useMe } from "@chess/shared";

export function AdminRoute() {
  const { data: me, isLoading } = useMe();
  if (isLoading) {
    return <div style={{ padding: 24 }}>Loading…</div>;
  }
  if (!me?.is_admin) {
    return <Navigate to="/app" replace />;
  }
  return <Outlet />;
}
